module.exports = __webpack_public_path__ + "media/images/official/special_sightseen_11-c305e7a7d5941ef068eaae4dcb5f821e.jpg";